import { useEffect, useRef } from 'react';
import { useBlocker } from 'react-router-dom';
import { useNavigationSafety } from '../contexts/NavigationSafetyContext';

export default function useUnsavedChanges(isDirty: boolean | (() => boolean), ignoreSearch = false, busy = false) {
  const dirty = typeof isDirty === 'function' ? isDirty() : isDirty;
  const id = useRef(Symbol('editor'));
  const update = useNavigationSafety()?.update;
  useEffect(() => {
    update?.(id.current, dirty, busy);
    const token = id.current;
    return () => update?.(token, false, false);
  }, [dirty, busy, update]);
  const blocker = useBlocker(({ currentLocation, nextLocation }) => (typeof isDirty === 'function' ? isDirty() : isDirty) && (
    currentLocation.pathname !== nextLocation.pathname || (!ignoreSearch && currentLocation.search !== nextLocation.search)
  ));

  useEffect(() => {
    if (!dirty) return;
    const warnBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = '';
    };
    window.addEventListener('beforeunload', warnBeforeUnload);
    return () => window.removeEventListener('beforeunload', warnBeforeUnload);
  }, [dirty]);

  return blocker;
}
